<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'dashboard.view_feature_photoservice_photographers'
    ])">{{ $gettext('My photo service') }}</CSidebarNavTitle>
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['dashboard.view_feature_photoservice_photographers'])"
      :name="$gettext('Photographers')"
      to="/my-photo-service/photographers"
      icon="cip-photographer"
    />
  </div>
</template>

<script>
export default {
  name: 'PhotoService'
}
</script>